export default "__VITE_ASSET__BkjfCUVh__"